import { useContext as r } from "react";
import { FeatureFlagContext as o } from "../FeatureFlagProvider.js";
const t = (t2) => !!r(o)[t2];
export {
  t as useFeatureFlag
};
//# sourceMappingURL=useFeatureFlag.js.map
